import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatForeignApplicantDetail,
	formatForeignApplicantList,
	formatForeignApplicantProgramList,
} from './foreign-applicant.helper';
import { ForeignApplicantActions } from './foreign-applicant.redux';
import {
	IPayloadCreateForeignApplicantRequest,
	IPayloadDeleteForeignApplicantRequest,
	IPayloadGetForeignApplicantDetailRequest,
	IPayloadGetForeignApplicantListRequest,
	IPayloadGetForeignApplicantProgramListRequest,
	IPayloadResetPasswordRequest,
} from './foreign-applicant.type';

export function* getForeignApplicantList(
	action: PayloadAction<IPayloadGetForeignApplicantListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetForeignApplicantListResponse> =
			yield API.getForeignApplicantList({ searchTypes, ...rest });

		const content = formatForeignApplicantList(res?.data?.content);

		yield put(
			ForeignApplicantActions.getForeignApplicantListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignApplicantActions.getForeignApplicantListFailure());
	}
}

export function* createForeignApplicants(
	action: PayloadAction<IPayloadCreateForeignApplicantRequest>
) {
	const { callback, ...props } = action.payload;

	try {
		yield API.createForeignApplicant({
			...props,
		});

		yield put(ForeignApplicantActions.createForeignApplicantSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignApplicantActions.createForeignApplicantFailure());
	}
}

export function* deleteForeignApplicants(
	action: PayloadAction<IPayloadDeleteForeignApplicantRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteForeignApplicant(ids);

		yield put(ForeignApplicantActions.deleteForeignApplicantSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignApplicantActions.deleteForeignApplicantFailure());
	}
}

export function* getForeignApplicantDetail(
	action: PayloadAction<IPayloadGetForeignApplicantDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.IForeignApplicant> =
			yield API.getForeignApplicantDetail(id);

		const foreignApplicantDetail = formatForeignApplicantDetail(res.data);

		yield put(
			ForeignApplicantActions.getForeignApplicantDetailSuccess({
				foreignApplicantDetail,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignApplicantActions.getForeignApplicantDetailFailure());
	}
}

export function* getForeignApplicantProgramListSaga(
	action: PayloadAction<IPayloadGetForeignApplicantProgramListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetForeignApplicantProgramListResponse> =
			yield API.getForeignApplicantProgramList({ ...rest });

		const content = formatForeignApplicantProgramList(res.data.content);
		yield put(
			ForeignApplicantActions.getForeignApplicantProgramListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignApplicantActions.getForeignApplicantProgramListFailure());
	}
}

export function* resetPasswordSaga(
	action: PayloadAction<IPayloadResetPasswordRequest>
) {
	const { callback, id } = action.payload;
	try {
		yield API.resetPassword(id);

		yield put(ForeignApplicantActions.resetPasswordSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignApplicantActions.resetPasswordFailure());
	}
}
